module.exports = __webpack_public_path__ + "img/chart.8ba53374.png";